export default __webpack_public_path__ + "img/twitter_hover.d6d45e4f0ae61513a50a8827098bed9f.svg";